module.exports = __webpack_public_path__ + "img/logo.81df51fa.svg";